import { environment } from '@/environments/environment';

enum ProfileType {
  BasicBeneficiary = 'BasicBeneficiary',
  BasicLender = 'BasicLender',
  AdvancedLender = 'AdvancedLender',
}

export const PROFILE_IDS: Record<ProfileType, string> = {
  [ProfileType.BasicBeneficiary]: environment.profiles.BasicBeneficiary,
  [ProfileType.BasicLender]: environment.profiles.BasicLender,
  [ProfileType.AdvancedLender]: environment.profiles.AdvancedLender,
};
